const DetailPanel = () => {
  return <p>receiving detail panel </p>
}

export default DetailPanel
